<div class="overflow-y-visible">
  <div class="max-h-[80vh]">
    <h4 class="text-lg font-bold">
      {{ '#UTILITIES.CONTEXT.TITLE' | translate }}
    </h4>
    @if (components && components.length === 0) {
      <div>
        {{ '#UTILITIES.CONTEXT.NO_COMPONENTS' | translate }}
      </div>
    }
    @for (component of components ?? []; track component; let last = $last) {
      <div class="mt-4 !overflow-y-visible">
        <ng-container *ngComponentOutlet="component"></ng-container>
        @if (!last) {
          <hr class="soft-separator" />
        }
      </div>
    }
  </div>
  <div class="flex flex-row justify-end">
    <button
      class="soft-button accent h-14 w-full mt-4"
      (click)="onSave()"
      [disabled]="loading$ | async"
      >
      @if (loading$ | async) {
        <i class="fa-regular fa-spinner fa-spin"></i>
      }
      {{ '#UTILITIES.CONTEXT.SAVE' | translate }}
    </button>
  </div>
</div>
